module.exports = __webpack_public_path__ + "img/top5.275e3870.png";